import React from 'react'

export default function InvoiceListFooterStyle() {
  return (
    <React.Fragment>
      <style jsx="true">
        {`
          #invoice-list-footer-container {
            display: flex;
            margin-right: 17px;
          }
        `}
      </style>
    </React.Fragment>
  )
}
